import React from 'react';
import { ChartBarIcon, DocumentArrowDownIcon, PresentationChartLineIcon } from '@heroicons/react/24/outline';
import CommonPageHeader from '../components/common/CommonPageHeader';

const FleetReports: React.FC = () => {
  return (
    <div className="space-y-6">
      <CommonPageHeader
        title="Riportok & Elemzések"
        subtitle="Flotta áttekintés, hatékonyság mutatók és exportálás"
        icon={ChartBarIcon}
      />

      {/* Flotta modul overlay */}
      <div className="relative">
        <div className="absolute inset-0 bg-gray-900/5 dark:bg-gray-900/20 backdrop-blur-[0.5px] z-10 rounded-lg flex items-center justify-center">
          <div className="bg-white/95 dark:bg-gray-800/95 px-8 py-6 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 max-w-md text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-primary-400 to-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">🚗</span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Flotta Modul</h3>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-4">
              Ez a funkció a Flotta modul részét képezi
            </p>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              A Riportok & Elemzések modul külön megrendelés tárgya.
            </p>
          </div>
        </div>

        {/* Teljes működő tartalom (elmosódva) */}
        <div className="pointer-events-none opacity-70 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
              <ChartBarIcon className="w-8 h-8 text-blue-600 mb-2" />
              <h3 className="font-semibold mb-1">Flotta kihasználtság</h3>
              <p className="text-2xl font-bold">87%</p>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
              <PresentationChartLineIcon className="w-8 h-8 text-green-600 mb-2" />
              <h3 className="font-semibold mb-1">Hatékonyság index</h3>
              <p className="text-2xl font-bold">92/100</p>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
              <DocumentArrowDownIcon className="w-8 h-8 text-purple-600 mb-2" />
              <h3 className="font-semibold mb-1">Exportált riportok</h3>
              <p className="text-2xl font-bold">24</p>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h3 className="text-lg font-semibold mb-4">Elérhető riportok</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                { name: 'Havi költség összesítő', icon: '📊' },
                { name: 'Járműnkénti teljesítmény', icon: '🚗' },
                { name: 'Üzemanyag fogyasztás elemzés', icon: '⛽' },
                { name: 'Karbantartási előzmények', icon: '🔧' },
                { name: 'Foglalási statisztika', icon: '📅' },
                { name: 'Költség-hatékonyság elemzés', icon: '💰' },
              ].map((report, i) => (
                <div key={i} className="border border-gray-200 dark:border-gray-700 rounded-lg p-4 flex items-center gap-3">
                  <span className="text-2xl">{report.icon}</span>
                  <div className="flex-1">
                    <p className="font-medium">{report.name}</p>
                    <p className="text-xs text-gray-500">PDF, Excel, CSV</p>
                  </div>
                  <button className="px-3 py-1 bg-blue-100 text-blue-700 rounded text-sm">
                    Export
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FleetReports;
